import { STRIPE } from "../constants";

const { ZERO_DECIMAL_CURRENCIES } = STRIPE;
const INTERVAL_MAP = {
  month: {
    1: "Monthly",
    2: "Bimonthly",
    3: "Quarterly",
  },
  week: {
    1: "Weekly",
    2: "Biweekly",
  },
};
const MINIMUM_MAP = {
  Weekly: 24,
  Biweekly: 12,
  Monthly: 6,
  Bimonthly: 3,
  Quarterly: 2,
};
const FREQUENCY_MAP = {
  month: {
    1: "month",
    2: "bimonthly",
    3: "quarter",
  },
  week: {
    1: "week",
    2: "biweekly",
  },
};

/**
 * Returns the divisor to use to calculate a price (1 if zero-decimal currency, 100 otherwise)
 *
 * @param currency {String} currency of the price
 * @returns {1 | 100} 1 | 100
 */
export const getDivisor = (currency = "usd") => {
  if (ZERO_DECIMAL_CURRENCIES.includes(currency.toUpperCase())) {
    return 1;
  }
  return 100;
};

/**
 * Returns the interval string to display
 *
 * @param currency {Object} recurring object
 * @returns {String} Interval string
 */
export const getIntervalString = (recurring) => {
  if (!recurring) return "";
  const { interval, interval_count } = recurring;
  let intervalString = "";
  if (interval === "month") {
    intervalString = INTERVAL_MAP[interval][interval_count] || "Monthly";
  } else if (interval === "year") {
    intervalString = "Annual";
  } else if (interval === "week") {
    intervalString = INTERVAL_MAP[interval][interval_count] || "Weekly";
  } else if (interval === "day") {
    intervalString = "Daily";
  }
  return `${intervalString}`;
};

export const getValidityText = (recurring) => {
  const { interval, interval_count } = recurring;
  if (interval === "day") {
    return `${interval_count} Day validity`;
  } else if (interval === "week") {
    return `${interval_count} Week validity`;
  } else if (interval === "year") {
    return `${interval_count} Year validity`;
  } else {
    return `${interval_count} Month validity`;
  }
};

export const getFeatures = (plan) => {
  const features = [];

  if (plan?.metadata) {
    Object.entries(plan.metadata).map(([key, value]) => {
      if (key.startsWith("feature")) {
        features.push(value);
      }
    });
  }
  return features.length > 0 ? features : null;
};

export const getMinimumTermLength = (interval) => {
  let length = 1;
  if (interval !== "Annual") {
    length = MINIMUM_MAP[interval];
  }
  return length;
};

export const getFrequencyString = (recurring, periods) => {
  if (!recurring) return "";
  const { interval, interval_count } = recurring;
  let intervalString = "";
  if (interval === "month") {
    intervalString = FREQUENCY_MAP[interval][interval_count] || "month";
  } else if (interval === "year") {
    intervalString = "Annual";
  } else if (interval === "week") {
    intervalString = FREQUENCY_MAP[interval][interval_count] || "week";
  } else if (interval === "day") {
    intervalString = "day";
  }

  return `${intervalString}${periods > 1 ? "s" : ""}`;
};
